// extracted by mini-css-extract-plugin
export default {"modalBackground":"adsDeleteModal_modalBackground__IMM3F","deleteModal":"adsDeleteModal_deleteModal__M+oBw","deleteModalButtons":"adsDeleteModal_deleteModalButtons__arM5w"};